import { HubConnectionState } from '@microsoft/signalr';

// Список всех кодов закрытия WebSocket:
export enum WS_CLOSE_CODE {
  // Завершение соединения с нормальной причиной, без ошибок.
  NORMAL_CLOSURE = 1000,

  // Сервер (или клиент) закрывает соединение, так как он будет перезапущен или перемещён.
  GOING_AWAY = 1001,

  // Ошибка протокола. Соединение закрывается из-за ошибки в процессе обмена сообщениями.
  PROTOCOL_ERROR = 1002,

  // Получены неподдерживаемые данные (например, неправильный тип данных).
  UNSUPPORTED_DATA = 1003,

  // Зарезервировано, не используйте.
  RESERVED = 1004,

  // Код закрытия не был передан, используется для обработки случаев, когда код закрытия не указан.
  NO_STATUS_RECEIVED = 1005,

  // Соединение закрылось неожиданно, без отправки закрывающего фрейма.
  ABNORMAL_CLOSURE = 1006,

  // Неверные данные в полезной нагрузке фрейма.
  INVALID_FRAME_PAYLOAD_DATA = 1007,

  // Нарушение политики, соединение закрывается из-за того, что обработанные данные не соответствуют политике.
  POLICY_VIOLATION = 1008,

  // Полученное сообщение слишком велико для обработки сервером.
  MESSAGE_TOO_BIG = 1009,

  // Расширение, необходимое для обработки запроса, отсутствует.
  MISSING_EXTENSION = 1010,

  // Внутренняя ошибка сервера, он не может обработать соединение.
  INTERNAL_ERROR = 1011,

  // Сервер перезапускается, и соединение закрывается.
  SERVICE_RESTART = 1012,

  // Сервер временно перегружен, клиенту рекомендуется повторить попытку позже.
  TRY_AGAIN_LATER = 1013,

  // Ошибка шлюза, сервер не может получить ответ от другого сервера.
  BAD_GATEWAY = 1014,

  // Ошибка во время TLS (Transport Layer Security) рукопожатия.
  TLS_HANDSHAKE = 1015,
}

export interface AddMemberModel {
  userId: string;
  userName: string;
}

export interface UserModel {
  userId: string;
  userName: string;
  online: boolean;
  isAvatarExists?: boolean;
  avatarSrc?: string;
}

export type UpdateUserModel = Partial<UserModel>;

export const ConnectionState = HubConnectionState;
export type ConnectionState = keyof typeof ConnectionState;
